var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10C2 5.58154 5.58154 2 10 2C14.4185 2 18 5.58154 18 10C18 14.4185 14.4185 18 10 18C5.58154 18 2 14.4185 2 10ZM12.9621 8.51159C13.0113 8.44599 13.0469 8.37121 13.0668 8.29165C13.0867 8.21209 13.0906 8.12935 13.078 8.04829C13.0655 7.96723 13.0369 7.8895 12.9939 7.81965C12.9509 7.7498 12.8944 7.68925 12.8277 7.64156C12.761 7.59387 12.6854 7.55999 12.6054 7.54193C12.5254 7.52387 12.4426 7.52198 12.3618 7.53638C12.2811 7.55078 12.204 7.58117 12.1352 7.62577C12.0664 7.67038 12.0072 7.72829 11.961 7.7961L9.30585 11.513L7.97333 10.1805C7.85668 10.0718 7.70238 10.0126 7.54296 10.0154C7.38353 10.0183 7.23142 10.0828 7.11867 10.1956C7.00592 10.3083 6.94134 10.4605 6.93852 10.6199C6.93571 10.7793 6.99489 10.9336 7.10359 11.0503L8.94974 12.8964C9.01291 12.9595 9.08907 13.0082 9.17291 13.0389C9.25676 13.0696 9.34629 13.0817 9.43529 13.0744C9.52429 13.0671 9.61063 13.0404 9.68831 12.9964C9.76599 12.9523 9.83315 12.8919 9.88513 12.8193L12.9621 8.51159Z",
    fill: "#15AE2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.bd894e4c45e061eba308bd398cba9a19.svg";
export { ForwardRef as ReactComponent };